import React, { useState, useEffect } from 'react';
import './styles/App.css';

// Components
import Header from './components/Header';
import Home from './components/Home';
import Post from './components/Post';
import Shop from './components/Shop';
import AIAssistant from './components/AIAssistant';
import Profile from './components/Profile';
import Navigation from './components/Navigation';

// Data
import {
  currentUser,
  posts,
  savedOutfits,
  interests,
  closetCategories,
  badges,
  inspirationalMessages,
  sampleUsers,
  shopData
} from './data/mockData';

// Custom hooks
import useLocalStorage from './hooks/useLocalStorage';

function App() {
  const [activeTab, setActiveTab] = useState('profile');
  const [profileTab, setProfileTab] = useState('calendar');
  const [user, setUser] = useLocalStorage('currentUser', currentUser);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [weather, setWeather] = useState({ temp: 72, condition: 'sunny' });

  const [userPosts, setUserPosts] = useLocalStorage('posts', posts);
  const [userOutfits, setUserOutfits] = useLocalStorage('savedOutfits', savedOutfits);
  const [userInterests, setUserInterests] = useLocalStorage('interests', interests);
  const [userCloset, setUserCloset] = useLocalStorage('closetCategories', closetCategories);
  const [userBadges, setUserBadges] = useLocalStorage('badges', badges);

  useEffect(() => {
    const timer = setInterval(() => setCurrentDate(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);

  const addToInterests = (item) => {
    if (!userInterests.find(existing => existing.item === item)) {
      setUserInterests([...userInterests, { brand: 'Unknown', item: item, price: 'N/A', image: '/api/placeholder/150/200' }]);
    }
  };

  return (
    <div className="max-w-sm mx-auto bg-black min-h-screen relative">
      <Header
        currentUser={user}
        currentDate={currentDate}
        weather={weather}
      />

      <div className="pb-16">
        {activeTab === 'home' && (
          <Home
            posts={userPosts}
            sampleUsers={sampleUsers}
            inspirationalMessages={inspirationalMessages}
            addToInterests={addToInterests}
            setActiveTab={setActiveTab}
          />
        )}

        {activeTab === 'post' && (
          <Post />
        )}

        {activeTab === 'shop' && (
          <Shop
            currentUser={user}
            shopData={shopData}
          />
        )}

        {activeTab === 'ai' && (
          <AIAssistant
            savedOutfits={userOutfits}
            weather={weather}
          />
        )}

        {activeTab === 'profile' && (
          <Profile
            currentUser={user}
            profileTab={profileTab}
            setProfileTab={setProfileTab}
            savedOutfits={userOutfits}
            interests={userInterests}
            closetCategories={userCloset}
            badges={userBadges}
          />
        )}
      </div>

      <Navigation
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
    </div>
  );
}

export default App;